import React, { useEffect, useContext } from 'react'
import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar'
import { AuthContext } from '../Context/AuthContext';

function WithNav() {
    const { cookies } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Remove client stylesheets when component mounts
        const clientStylesheets = [
            "assets1/css/vendor/bootstrap.min.css",
            "assets1/css/vendor/slick.css",
            "assets1/css/vendor/slick-theme.css",
            "assets1/css/plugins/sal.css",
            "assets1/css/plugins/feather.css",
            "assets1/css/plugins/fontawesome.min.css",
            "assets1/css/plugins/euclid-circulara.css",
            "assets1/css/plugins/swiper.css",
            "assets1/css/plugins/magnify.css",
            "assets1/css/plugins/odometer.css",
            "assets1/css/plugins/animation.css",
            "assets1/css/plugins/bootstrap-select.min.css",
            "assets1/css/plugins/jquery-ui.css",
            "assets1/css/plugins/magnigy-popup.min.css",
            "assets1/css/plugins/plyr.css",
            "assets1/css/style.css"
        ];

        // Find and remove client stylesheets
        const links = document.getElementsByTagName('link');
        for (let i = links.length - 1; i >= 0; i--) {
            const link = links[i];
            if (clientStylesheets.some(stylesheet => link.href.includes(stylesheet))) {
                link.parentNode.removeChild(link);
            }
        }
    }, []);

    // Check if user is admin
    const isAdmin = cookies.RoleName === 'admin';

    // If not admin, redirect to home page and reload
    if (!isAdmin) {
        window.location.href = '/';
        return null;
    }

    return (
        <>
            <Navbar />
        </>
    )
}

export default WithNav;
